import React from 'react';
import { PricingSection } from './PricingSection';
import { FadeIn } from './ui/FadeIn';
export const FinalCTA = () => {
  return <div className="bg-navy-900 pt-6 md:pt-12" data-id="element-110">
      <FadeIn className="text-center px-4" data-id="element-111">
        <h2 className="text-3xl md:text-7xl font-bebas text-white mb-2 md:mb-4 text-glow-gold" data-id="element-112">
          No dejes pasar esta oportunidad
        </h2>
      </FadeIn>
      {/* Reusing PricingSection as it contains the countdown and pricing cards as requested */}
      <PricingSection data-id="element-113" />
    </div>;
};